import { isPlatformBrowser } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component, Inject, Optional, PLATFORM_ID } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import readXlsxFile from 'read-excel-file';
import { firstValueFrom, Subscription } from 'rxjs';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { MasterSolutionDetailImportModel } from 'src/app/models/imports/master-solution-detail-import';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { MasterSolutionDetailService } from 'src/app/services/preliminaries/master-solution-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-import-master-solution-detail',
  templateUrl: './import-master-solution-detail.component.html',
  styleUrls: ['./import-master-solution-detail.component.scss'],
  standalone: false
})
export class ImportMasterSolutionDetailComponent {

  eventFile: any;
  errorMasterSolutionDetail: number = 0;
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = '';
  masterSolutionDetailAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  masterSolutionId: number = 0;
  masterSolutionDetailImport: boolean = false;
  subscription: Subscription;
  visibleTxt: boolean = false;

  constructor(private masterSolutionDetailService: MasterSolutionDetailService,
    public config: DynamicDialogConfig,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef,
    @Inject(PLATFORM_ID) private platformId: object) { }

  async ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.subscription = input$?.subscribe((inputs: any) => {
      this.masterSolutionId = inputs.masterSolutionId;
    });
  }

  attachFileImport() {
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('fileImport')?.click();
    }
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      if (isPlatformBrowser(this.platformId)) {
        this.eventFile.target.value = '';
      }
    }
  }

  close() {
    const data: ModalObjectType = {};
    if (this.masterSolutionDetailImport) {
      data.params = { reload: true };
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  downloadErrorsTxt() {
    if (!this.masterSolutionDetailAlerts || this.masterSolutionDetailAlerts.length === 0) {
      this.toastHandlerService.showToast('error', 'No hay alertas para exportar');
      return;
    }

    this.masterSolutionDetailService.exportImportErrors(this.masterSolutionDetailAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionMaestradeSoluciones_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast('error', 'Error al exportar el archivo');
      }
    });
  }

  downloadGuideImport() {
    this.masterSolutionDetailService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaMaestraDeSolución.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  importSolutions() {
    this.masterSolutionDetailAlerts = [];
    this.errorMasterSolutionDetail = 0;
    this.visibleTxt = false;
    if (isPlatformBrowser(this.platformId)) {
      let isOk: boolean = true;
      const input = document.getElementById("fileImport") as any;
      const rowsImports = new Array<MasterSolutionDetailImportModel>();
      let row: MasterSolutionDetailImportModel;
      let counter: number = 1, consecutiveMasterSolution: number, articleCode: number, articleName: string, quantity: number;
      if (input.files[0]) {
        readXlsxFile(input.files[0]).then(async (rows) => {
          if (rows.length <= 1) {
            Swal.fire({
              icon: 'error',
              title: 'Error.',
              text: "El archivo ingresado no tiene registros para importar."
            });
            return;
          }
          rows.splice(0, 1);
          rows.forEach(element => {
            counter = counter + 1;
            let rowHasError = false;

            //A. Consecutivo solución:
            const valueSolutionConsecutive = element[0];
            if (valueSolutionConsecutive == null || valueSolutionConsecutive === "") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna A. El consecutivo de la solución no es válido.`;
              this.masterSolutionDetailAlerts.push(alert);
              rowHasError = true;
            }
            consecutiveMasterSolution = Number(valueSolutionConsecutive);
            if (isNaN(consecutiveMasterSolution)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna A. El consecutivo de la solución no es válido.`;
              this.masterSolutionDetailAlerts.push(alert);
              rowHasError = true;
            }

            //B. Código Artículo:
            const valueArticleCode = element[1];
            if (valueArticleCode == null || valueArticleCode === "") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna B. El código del artículo no es válido.`;
              this.masterSolutionDetailAlerts.push(alert);
              rowHasError = true;
            }
            articleCode = Number(valueArticleCode);
            if (isNaN(articleCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna B. El código del artículo no es válido.`;
              this.masterSolutionDetailAlerts.push(alert);
              rowHasError = true;
            }

            //  C. Nombre Artículo:
            articleName = element[2] as string;
            if (articleName != null && articleName.length > 200) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna C. El nombre del artículo: supera el tamaño máximo de caracteres (200)`;
              this.masterSolutionDetailAlerts.push(alert);
              rowHasError = true;
            }

            //E. Cantidad
            const valueQuantity = element[3];
            if (valueQuantity == null || valueQuantity === "") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna D. La cantidad no es válida.`;
              this.masterSolutionDetailAlerts.push(alert);
              rowHasError = true;
            }
            quantity = Number(valueQuantity);
            if (isNaN(quantity)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna D. La cantidad no es válida.`;
              this.masterSolutionDetailAlerts.push(alert);
              rowHasError = true;
            }

            if (!rowHasError) {
              row = new MasterSolutionDetailImportModel(counter, this.masterSolutionId,
                consecutiveMasterSolution, articleCode, articleName, quantity);
              rowsImports.push(row);
            } else {
              isOk = false;
            }
          });
          if (isOk && rowsImports.length > 0) {
            try {
              const response = await firstValueFrom(this.masterSolutionDetailService.importSolutionDetails(rowsImports));
              this.loadPreInvoicingModel = response;
              this.masterSolutionDetailAlerts = response?.alerts ?? [];
              this.errorMasterSolutionDetail = response?.preInvoicingStateId;

              if (this.errorMasterSolutionDetail === 1) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast(
                  'error',
                  'La importación terminó con errores, puede exportarlos si lo desea.',
                  'ERROR');
              } else if (this.masterSolutionDetailAlerts.length > 0) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast('error', 'La importación terminó con alertas, puede exportarlas si lo desea');
              } else {
                this.visibleTxt = false;
                this.toastHandlerService.showToast('success', `La importación terminó exitosamente.`);
              }
              this.masterSolutionDetailImport = true;
              this.clearInputFile();
            } catch (error) {
              this.nameFile = 'Ningún archivo seleccionado.';
              console.error('Error al importar Topes Máximos-Mínimos.', error);
            }
          } else {
            this.errorMasterSolutionDetail = 1;
            this.visibleTxt = true;
            this.toastHandlerService.showToast(
              'error',
              'La importación terminó con errores, puede exportarlos si lo desea'
            );
          }
        });
      } else {
        this.toastHandlerService.showToast('error', 'No ha seleccionado ningún archivo.');
      }
    }
  }
}
